export const bucketUrl = process.env.REACT_APP_BUCKET_URL;
export const getFileType =(filePath)=> {
    if (!filePath || typeof filePath !== "string") return "unknown";
  
    // Extract extension
    const ext = filePath.split('.').pop().toLowerCase();
  
    const imageExt = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "tiff", "svg"];
    const videoExt = ["mp4", "mkv", "avi", "mov", "wmv", "flv", "webm", "mpeg"];
    const fileExt = ["pdf"];
  
    if (imageExt.includes(ext)) {
      return "image";
    } else if (videoExt.includes(ext)) {
      return "video";
    }  else if (fileExt.includes(ext)) {
      return "file";
    } else {
      return "unknown";
    }
  }
  

  // config: add or tweak patterns as needed
  const phoneFormats = {
    "1": {   // United States, Canada, and much of the Caribbean
      country: [
        "United States", "Canada", "American Samoa", "Anguilla", "Antigua and Barbuda",
        "Bahamas", "Barbados", "Bermuda", "British Virgin Islands", "Cayman Islands",
        "Dominica", "Dominican Republic", "Grenada", "Guam", "Jamaica", "Montserrat",
        "Northern Mariana Islands", "Puerto Rico", "Saint Kitts and Nevis", "Saint Lucia",
        "Saint Vincent and the Grenadines", "Sint Maarten", "Trinidad and Tobago",
        "Turks and Caicos Islands", "U.S. Virgin Islands"
      ],
      regex: /^(\d{3})(\d{3})(\d{4})$/,
      format: "($1) $2-$3"
    },
    "44": {  // United Kingdom
      country: ["United Kingdom"],
      regex: /^(\d{2})(\d{4})(\d{4})$/,
      format: "$1 $2 $3"
    },
    "91": {  // India
      country: ["India"],
      regex: /^(\d{5})(\d{5})$/,
      format: "$1-$2"
    },
    "61": {  // Australia
      country: ["Australia"],
      regex: /^(\d{4})(\d{3})(\d{3})$/,
      format: "$1 $2 $3"
    },
    "81": {  // Japan
      country: ["Japan"],
      regex: /^(\d{2})(\d{4})(\d{4})$/,
      format: "$1-$2-$3"
    },
    "49": {  // Germany
      country: ["Germany"],
      regex: /^(\d{3,4})(\d{6,7})$/,
      format: "$1 $2"
    },
    "33": {  // France
      country: ["France"],
      regex: /^(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/,
      format: "$1 $2 $3 $4 $5"
    },
    "39": {  // Italy
      country: ["Italy"],
      regex: /^(\d{2,4})(\d{6,8})$/,
      format: "$1 $2"
    },
    "7": {   // Russia, Kazakhstan
      country: ["Russia", "Kazakhstan"],
      regex: /^(\d{3})(\d{3})(\d{2})(\d{2})$/,
      format: "$1 $2-$3-$4"
    },
    "86": {  // China
      country: ["China"],
      regex: /^(\d{3})(\d{4})(\d{4})$/,
      format: "$1 $2 $3"
    }
  };
  

export const formatPhoneNumber = (phone, countryCode) => {
  if (phone === null || phone === undefined) return "";

  // keep only digits
  let cleaned = String(phone).replace(/\D/g, "");
  const cc = String(countryCode).replace(/\D/g, "");

  // strip country code from beginning if present
  if (cc && cleaned.startsWith(cc)) {
    cleaned = cleaned.slice(cc.length);
  }

  // strip leading trunk zero(s)
  cleaned = cleaned.replace(/^0+/, "");

  const config = phoneFormats[cc];

  if (config) {
    const match = cleaned.match(config.regex);
    if (match) {
      const local = config.format.replace(/\$(\d)/g, (_, g) => match[Number(g)] || "");
      return `+${cc} ${local}`; 
    }
  }

  // fallback
  return `${cleaned}`;
};

  
export const helpPagesData = {
  pages: {
      title: "Pages",
      message:
          "This section provides assistance and guidance on how to use the CMS effectively. Here you can find FAQs, tutorials, and contact information for further support.",
      items: [
          "Pages are your layout of content composed of sections.",
          "Sections can be saved as templates and reused.",
          "Within a section, you can reorder subsections or any field; page reflects changes after publishing.",
          "SEO options available: set meta-tags, title, slug, etc.",
      ],
  },
  media: {
      title: "Media Library",
      message:
          "Upload, manage, and organize your images and videos in the Media Library.",
      items: [
          "Supports bulk uploads for images and videos.",
          "Drag & drop to reorder files.",
          "Preview media before inserting into pages.",
      ],
  },
};

export const isVideo = (url = "") =>
  /\.(mp4|webm|ogg|mov)$/i.test(url);

export const imageUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("//") ||
    trimmed.startsWith("data:")
  ) {
    return trimmed;
  }
  if (trimmed.startsWith("assets/") || trimmed.startsWith("/assets/")) {
    return `http://localhost:3000/${trimmed.replace(/^\/+/, "")}`;
  }
  const bucket = (process.env.REACT_APP_BUCKET_URL || "").replace(/\/+$/, "");
  return `${bucket}/${trimmed.replace(/^\/+/, "")}`;
};